import DapDSProgress from './progress.component'

export * from './progress.component'
export default DapDSProgress

DapDSProgress.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-progress': DapDSProgress
  }
}
